module.exports = __webpack_public_path__ + "img/social-media-+-database.ae755d60.svg";